import { styled } from '@linaria/react';

export const ExternalIdsTable = styled.table`
    width: 100%;
    border-collapse: collapse;

    th,
    td {
        padding: 0.5rem;
        border-bottom: 1px solid #e5e7eb;
        text-align: left;
        vertical-align: middle;
    }

    th:first-child,
    td:first-child {
        width: 36px;
    }
`;

export const RemoveExternalIdButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1rem;
    padding: 0.25rem;
    opacity: 0.7;

    &:hover {
        opacity: 1;
    }
`;

export const EditInput = styled.input`
    width: 100%;
    padding: 0.4rem 0.5rem;
    border: 1px solid #cbd5e1;
    border-radius: 4px;
    font-size: 0.875rem;

    &:focus {
        outline: none;
        border-color: #2563eb;
        box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
    }
`;

export const NewEntryCell = styled.div`
    display: flex;
    gap: 0.5rem;
    align-items: center;
`;

export const AddButton = styled.button`
    padding: 0.4rem 0.75rem;
    border: 1px solid #2563eb;
    background: #2563eb;
    color: #fff;
    border-radius: 4px;
    font-size: 0.875rem;
    cursor: pointer;

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const FromCategoryLabel = styled.span`
    color: #6b7280;
`;

export const EmptyMessage = styled.div`
    color: #6b7280;
    font-style: italic;
    padding: 0.5rem 0;
`;
